function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "FIFA",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12 4C16.4184 4 20 7.5816 20 12C20 16.4184 16.4184 20 12 20C7.5816 20 4 16.4184 4 12C4 7.5816 7.5816 4 12 4ZM13.336 15.2H10.664L9.56 16.7176L10.0032 18.0824C10.6477 18.2935 11.3218 18.4007 12 18.4C12.6968 18.4 13.368 18.288 13.9968 18.0824L14.4392 16.7176L13.3352 15.2H13.336ZM6.6352 11.0976L5.6016 11.8472L5.6 12C5.6 13.384 6.0392 14.6648 6.7856 15.712H8.3136L9.372 14.256L8.5496 11.72L6.6352 11.0976V11.0976ZM17.3648 11.0976L15.4504 11.72L14.628 14.256L15.6856 15.712H17.2136C17.9871 14.6289 18.4019 13.3309 18.4 12L18.3976 11.8472L17.3648 11.0976V11.0976ZM13.832 5.8664L12.8 6.6184V8.632L14.9552 10.1976L16.7464 9.616L17.1896 8.2536C16.3637 7.1103 15.1839 6.27124 13.8328 5.8664H13.832ZM10.1664 5.8664C8.81523 6.27145 7.63537 7.1108 6.8096 8.2544L7.2528 9.616L9.044 10.1976L11.2 8.632V6.6184L10.1672 5.8664H10.1664Z",
  fill: "white"
}));

var SvgFifa = function SvgFifa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFifa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fifa.6b2161e4.svg";
export { ForwardRef as ReactComponent };